import React from 'react';
import './Country.css'

const Country = (props) => {

 const {area, region, population, name ,flags} = props.country
 return (
  <div className='country'>

{/* HOW TO GET DATA BY DOING DISTRACUTREING from line 6 */}
   <h1>Country Name : {name.common} </h1>
   <img src={flags.png}/>
   <p>Total Population : {population}</p>
   <p>Continent : {region}</p>
   <p>Total Area : {area}</p>

{/*    <h1>Country Name : {props.country.name.common} </h1>
   <p>Total Population : {props.country.population}</p>
   <p>Continent : {props.country.region}</p>
   <p>Total Area : {props.country.area}</p> */}


{/* THIS ONE METHOD HOW DISPLLAY DATA ESALY  */}
   {/* <h1>Country Name : {props.name.common} </h1>
   <p>Total Population : {props.population}</p>
   <p>Continent : {props.region}</p>
   <p>Total Area : {props.area}</p> */}

  </div>
 );
};

export default Country;